import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { MouseEvent, useState } from "react";

import { TableCsvExportState } from "./useTableCsvExport";

export interface TableCsvDownloadMenuProps {
  exportState: TableCsvExportState;
  /** Additional caller-side restriction; true never overrides hook authorization. */
  visible?: boolean;
}

export const TableCsvDownloadMenu = ({
  exportState,
  visible = true
}: TableCsvDownloadMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  if (!visible || !exportState.isAuthorized) {
    return null;
  }

  const close = () => setAnchorEl(null);
  const choose = (action: () => Promise<void>) => async () => {
    close();
    await action();
  };

  return (
    <>
      <IconButton
        aria-controls={open ? "table-csv-download-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="menu"
        aria-label="Export page"
        disabled={exportState.isLoading}
        onClick={(event: MouseEvent<HTMLButtonElement>) =>
          setAnchorEl(event.currentTarget)
        }
      >
        <DownloadOutlinedIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="table-csv-download-menu"
        MenuListProps={{ "aria-label": "CSV export options" }}
        onClose={close}
        open={open}
      >
        <MenuItem
          disabled={exportState.isLoading}
          onClick={choose(exportState.downloadCsv)}
        >
          <ListItemIcon>
            <DownloadOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Download page as CSV
        </MenuItem>
        <MenuItem
          disabled={exportState.isLoading}
          onClick={choose(exportState.copyCsv)}
        >
          <ListItemIcon>
            <ContentCopyOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Copy page as CSV
        </MenuItem>
      </Menu>
    </>
  );
};
